import { apiClient } from '@/lib/api/client';
import { API_ENDPOINTS } from '@/lib/api/config';
import type {
  Shipment,
  ReceptionSession,
  ReceptionSessionItem,
  VerifyCountRequest,
  ReportDiscrepancyRequest,
  VerifyItemRequest,
  ShipmentsListParams,
  ReceptionMetrics,
  ReceptionSummary
} from '../types';

const { RECEPTION } = API_ENDPOINTS;

export const receptionApi = {
  getShipments: (params?: ShipmentsListParams) =>
    apiClient.getPaginated<Shipment>(RECEPTION.SHIPMENTS, params),

  getShipment: (id: number) => apiClient.get<Shipment>(RECEPTION.SHIPMENT(id)),

  metrics: () => apiClient.get<ReceptionMetrics>(RECEPTION.METRICS),

  bulkDelete: (
    params:
      | { ids: number[] }
      | { all: true; filters: Partial<ShipmentsListParams> }
  ) => apiClient.post(RECEPTION.BULK_DELETE, params),

  verifyQr: (shipmentId: number) =>
    apiClient.post<ReceptionSession>(RECEPTION.VERIFY_QR(shipmentId)),

  verifyQrByNumber: (shipmentNumber: string) =>
    apiClient.post<ReceptionSession>(RECEPTION.VERIFY_QR_BY_NUMBER, {
      shipment_number: shipmentNumber
    }),

  verifyCount: (sessionId: number, data: VerifyCountRequest) =>
    apiClient.post<ReceptionSession>(RECEPTION.VERIFY_COUNT(sessionId), data),

  reportDiscrepancy: (sessionId: number, data: ReportDiscrepancyRequest) =>
    apiClient.post<ReceptionSession>(
      RECEPTION.REPORT_DISCREPANCY(sessionId),
      data
    ),

  verifyItem: (sessionId: number, data: VerifyItemRequest) =>
    apiClient.post<ReceptionSessionItem>(
      RECEPTION.VERIFY_ITEM(sessionId),
      data
    ),

  getSummary: (sessionId: number) =>
    apiClient.get<ReceptionSummary>(RECEPTION.SUMMARY(sessionId)),

  complete: (sessionId: number) =>
    apiClient.post<ReceptionSession>(RECEPTION.COMPLETE(sessionId)),

  filterOptions: (params: {
    field: string;
    page?: number;
    per_page?: number;
    search?: string;
  }) =>
    apiClient.getPaginated<{ value: string }>(RECEPTION.FILTER_OPTIONS, params)
};
